module.exports = __webpack_public_path__ + "static/media/29EUNOG5.99e4975b.jpg";